module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1512-2ab3835399ffc4f36b4570f396e1a81b.png";